import './index.scss';
import React from 'react';
import { Tv } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SuccessMessage from '../../../shared/SuccessMessage';
import { useCloseOldModal } from '../../../../store/modal/modalHooks';

const BookSuccessMessage = () => {
  const icon = <Tv />;
  const history = useHistory();
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();

  return (
    <div>
      <div className="success-message-container">
        <SuccessMessage
          icon={icon}
          title={t('BOOKED_SUCCESSFULLY')}
          buttonLabel={t('VIEW_BOOKINGS')}
          onClick={() => {
            closeModal();
            history.push('/my-activities');
          }}
        />
      </div>
    </div>
  );
};

export default BookSuccessMessage;
